import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

// Las flechas, a los lados y a media altura. Swiper les pone `swiper-button-disabled` al llegar a un extremo (y a las dos si todas las
// tarjetas caben): ahí se esconden
const flechaSx = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  bgcolor: 'rgba(255, 255, 255, 0.8)',
  boxShadow: 2,
  zIndex: 10,
  width: 32,
  height: 32,
  '&:hover': { bgcolor: 'white' },
  '&.swiper-button-disabled': { display: 'none' },
};

// El carrusel de tarjetas de la web («Servicios destacados», «Perfiles de proveedores»): de 1 a 4 por fila según el ancho, todas del mismo
// alto (cada una con `height: 100%` llena su lugar). Cada hijo es una tarjeta. `etiquetas`: el nombre de las flechas para quien no las ve;
// `style`: el del carrusel, para darle aire si sus tarjetas se levantan o tienen sombra
const Carrusel = ({ children, etiquetas = ['Anteriores', 'Siguientes'], style }) => {
  // Swiper recibe las flechas cuando ya existen en el DOM
  const [prevEl, setPrevEl] = useState(null);
  const [nextEl, setNextEl] = useState(null);

  return (
    <Box sx={{ position: 'relative' }}>
      <Swiper
        modules={[Navigation]}
        spaceBetween={16}
        slidesPerView={1}
        navigation={{ prevEl, nextEl }}
        breakpoints={{
          640: { slidesPerView: 2 },
          900: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        style={{ paddingBottom: '10px', ...style }}
      >
        {React.Children.map(children, (tarjeta) => (
          <SwiperSlide style={{ height: 'auto' }}>{tarjeta}</SwiperSlide>
        ))}
      </Swiper>

      <IconButton ref={setPrevEl} aria-label={etiquetas[0]} className="swiper-nav-button" sx={{ ...flechaSx, left: 5 }}>
        <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
      </IconButton>
      <IconButton ref={setNextEl} aria-label={etiquetas[1]} className="swiper-nav-button" sx={{ ...flechaSx, right: 5 }}>
        <ArrowForwardIosIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
};

export default Carrusel;
